import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import Card from "components/ui/Card";
import { useLocation, useNavigate } from "react-router-dom";
import { settingsRoutes } from "constants/constants";
import "./settingscreen.css";
import { ProfileModal } from "./profile/components/profile-modal";
import { useSettingContext } from "context/SettingContext";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificSubMenu, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { useGlobalContext } from "context/GlobalContext";

function SettingScreen() {
  const permissions = usePermissions();
  const findPage = findSpecificMenu("Settings", permissions);
  const navigate = useNavigate();
  const location = useLocation();

  const [openProfile, setOpenProfile] = useState(false);
  const { setIsRightPage, setSelectRoleOptions, setIsLimitPage, setSelectRoleBtnName, setRateMaster, setSearch } = useSettingContext();
  const { setSortValue, sortValue, setSortOptions } = useGlobalContext();

  useEffect(() => {
    if (location.state?.restrictedCategorySearch || location.state?.restrictedSubCatgeorySearch) {
      const { restrictedCategorySearch, restrictedSubCatgeorySearch, ...newState } = location.state || {};
      navigate(location.pathname, { state: newState, replace: true });
    }
  }, []);

  const handleClick = (name, path, replace) => {
    if (name === "Users") {
      setSearch("");
      setSortOptions([]);
      setSortValue("");
    }
    if (name === "Profile") {
      return setOpenProfile(true);
    }

    if (name === "Rights") {
      setIsRightPage(true);
      localStorage.setItem("roleButtonName", "Select Role");
      setSelectRoleBtnName("Select Role");
    }

    // if (name === "Limits") {
    //   setIsLimitPage(true);
    //   localStorage.setItem("roleButtonName", "Select User");
    //   setSelectRoleBtnName("Select User");
    // }

    if (replace) {
      name = replace;
    }
    const state = { ...location.state, name: [`${name}`] };

    // For Melting Requests - you can add specific handling if needed
    if (name === "Melting Requests") {
      console.log("Melting Requests clicked - path:", path);
    }

    navigate(`/Setting/${path}`, { state });
  };

  const style = {
    justifyContent: "center",
    fontFamily: "Karla",
    fontWeight: "400",
    fontSize: "20px",
    minWidth: 275,
    maxWidth: "317px",
    height: 62,
    borderRadius: "5px",
  };

  const handleCloseProfile = () => {
    setOpenProfile(false);
  };

  const Synchronize = ["Sub - Category", "Make Type", "Sets", "Collection", "Design Restriction", "Design Class"];

  const permissionsCheck = ({ permission, key }) => {
    if (permissions && permissions?.isAdmin) {
      return true;
    }
    let allowed = false;

    if (!permission || !permission.permissions) {
      return false;
    }

    if (key === "all") {
      allowed = permission.permissions.some((p) => p.allowed === true);
    } else {
      const searchKey = key.toLowerCase();

      const matchingPermission = permission.permissions.find((p) => p.key && p.key.toLowerCase() === searchKey);

      if (matchingPermission) {
        allowed = matchingPermission.allowed === true;
      }
    }

    return allowed;
  };

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        sx={{ paddingLeft: "18px", paddingRight: "18px" }}
        rowSpacing={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}
        columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}
        justifyContent="space-beetween"
        alignItems="center"
      >
        {settingsRoutes.map((route, i) => {
          const { name, path, check, replace } = route;
          const hasDesignUpdateAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Upadte"), "view");
          const hasDesignImportAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Import"), "view");
          if (check === "Design Import" && !hasDesignImportAccess) {
            return null;
          }
          // Debug log to see all routes

          // if (check !== "Design Import") {
          let findSubPage;
          if (
            check === "Synchronize" ||
            check === "Main Activity" ||
            check === "Roles" ||
            check === "Rights" ||
            check === "Restricted Designs" ||
            check === "Missing Images" ||
            check === "Rate Master Rights" ||
            check === "Waba Rights" ||
            check === "Design Update" ||
            check === "Update Images" ||
            check === "Labour Rights" ||
            check === "Product USP & Gallery" ||
            check === "My Binny’s Access" ||
            check === "Stock Tray" ||
            check === "Event Type" ||
            check === "Service Request" ||
            check === "Melting Requests" ||
            check === "Orders" ||
            check === "Design Import" ||
            check === "Profile" ||
            check === "Limits" ||
            check === "Archives" ||
            check === "User" ||
            check === "New Rights"
          ) {
            if (check === "Synchronize") {
              findSubPage = Synchronize.some((subMenu) =>
                permissionsCheck({
                  permission: findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), subMenu),
                  key: "view",
                })
              );
            }
            if (check === "Main Activity") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Main Activity"), "view");
            }
            if (check === "Restricted Designs") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Restricted Designs"), "view");
            }
            if (check === "Roles") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Roles"), "view");
            }
            if (check === "Limits") {
              findSubPage = permissionsCheck({ permission: findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Limits"), key: "all" });
            }
            if (check === "User") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "User"), "view");
            }
            if (check === "Archives") {
              findSubPage = permissionsCheck({ permission: findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Archives"), key: "all" });
            }
            if (check === "Rights") {
              // findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view");
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view");
            }
            if (check === "Missing Images") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Missing Images"), "view");
            }
            if (check === "Design Import") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Import"), "view");
            }
            if (check === "Profile") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Profile"), "view");
            }
            if (check === "Rate Master Rights") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rate Master Rights"), "view");
            }
            if (check === "Waba Rights") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Waba Rights"), "view");
            }
            if (check === "Design Update") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Update"), "view");
            }
            if (check === "Update Images") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Update Images"), "view");
            }
            if (check === "Labour Rights") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Labour Rights"), "view");
            }
            if (check === "Product USP & Gallery") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Product USP and Gallery"), "view");
            }
            if (check === "My Binny’s Access") {
              // findSubPage = hasAccessPage(findSpecificMenu("My Binny’s App", permissions), "view");
              findSubPage = permissionsCheck({ permission: findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), key: "view" });
            }
            if (check === "Stock Tray") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Stock Tray"), "view");
            }
            if (check === "Event Type") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Event Type"), "view");
            }
            if (check === "Service Request") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Service Requests"), "view");
            }
            if (check === "Melting Requests") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Melting Request"), "view");
            }
            if (check === "Orders") {
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes"), "view");
            }
            if (check === "New Rights") {
              //  findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view");
              findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view");
            }
          } else {
            // findSubPage = hasAccessSubPage(findSpecificSubMenu(findPage, check), "view");
          }

          if (!findSubPage) {
            // console.log("Hiding button for:", check, "because findSubPage is false");
            return null;
          }
          // }

          // Debug log for visible buttons
          if (check === "Melting Requests") {
          }

          return (
            <Grid item xs={12} sm={12} md={4} lg={3} xl={2.3} key={i} onClick={() => handleClick(name, path, replace)}>
              <Card style={style}>
                {/* <div>{name}</div> */}
                <Typography fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {name}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <ProfileModal open={openProfile} close={handleCloseProfile} />
    </>
  );
}

export default SettingScreen;
